module.exports = __webpack_public_path__ + "img/silver3.acd9c790.png";